module.exports = __webpack_public_path__ + "static/media/welcome-banner.6f290d2b.jpg";